import { render, staticRenderFns } from "./pdfViewer.vue?vue&type=template&id=764ffe26&"
import script from "./pdfViewer.vue?vue&type=script&lang=js&"
export * from "./pdfViewer.vue?vue&type=script&lang=js&"
import style0 from "./pdfViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports